import { Auth } from "aws-amplify";
import moment from "moment";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { AppMessages } from "./app.messages";
// get current user time zone
const offsetOfCurrentUser = new Date().getTimezoneOffset();

export function getDefaultValue(value: string | undefined | null) {
  if (value === undefined || value === null) return "";
  return value;
}

export function getCurrentDateTime(format = "YYYY-MM-DDTHH:mm") {
  return moment().format(format);
}
export function getUTCDateTime(date: string | null | undefined) {
  if (!date || date === "") {
    return null;
  } else if (date?.includes("T")) {
    return date;
  } else {
    const currentTime = new Date();
    const neDateTime = moment(date).hours(currentTime.getHours()).minutes(currentTime.getMinutes());
    return moment.utc(neDateTime).format("YYYY-MM-DDTHH:mm");
  }
}
export function setDateTimeFormate(date?: string, formate?: string) {
  if (date) {
    let neDate = date;
    if (date.includes("UTC")) neDate = date.replace("UTC", "");
    return moment(neDate).format(formate || "MM/DD/YYYY hh:mm A");
  } else {
    return "";
  }
}

/*
 *   Convert UTC to local time
 */

export function getLocalDateTime(date: string | null | undefined, format = "YYYY-MM-DDTHH:mm") {
  if (!date || date === "") {
    return null;
  } else if (typeof date === "string" && date?.includes("T")) {
    return moment.utc(date).local().format(format);
  } else {
    return date;
  }
}
// Add time to date and convert dateTime to utc wrt current login User (for End date)
export function getUTCDateTimeWithEndOfDay(date: string | null | undefined) {
  return !date || date === ""
    ? null
    : moment
        .utc(new Date(date))
        .endOf("day")
        .utcOffset(offsetOfCurrentUser)
        .format("YYYY-MM-DDTHH:mm");
}
// Add time to date and convert dateTime to utc wrt current login User (for start date)
export function getUTCDateTimeWithStartOfDay(date: string | null | undefined) {
  return !date || date === ""
    ? null
    : moment
        .utc(new Date(date))
        .startOf("day")
        .utcOffset(offsetOfCurrentUser)
        .format("YYYY-MM-DDTHH:mm");
}

export async function getAccessJwtToken() {
  // Auth.currentSession() checks if token is expired and refreshes with Cognito if needed automatically
  const session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
}

const setDateTimeToLocal = (date: string | null): string | null => {
  const res = date ? moment.utc(date).local().format("YYYY-MM-DDTHH:mm") : null;
  return res;
};

const setDateToLocal = (date: string | null): string | null => {
  const res = date ? moment.utc(date).local().format("YYYY-MM-DD") : null;
  return res;
};
export function setDateToLocalFormated(date: string | null | undefined) {
  const res = date ? moment.utc(date).local().format("MM/DD/YYYY") : null;
  return res;
}

const setDateField = (date: string | null): string | null => {
  const res = !date || date === "" ? null : moment.utc(new Date(date as string)).format();
  return res;
};

export function showNotification(notiMessage: string, variant: any, dispatch: any) {
  dispatch(
    addNotificationAction({
      message: AppMessages.get(notiMessage) || notiMessage,
      options: { variant: variant },
    })
  );
}

export { setDateTimeToLocal, setDateField, setDateToLocal };

const trimWhitespaceAndPunctuation = (value: string): string => {
  const punctuation = new Set([",", ".", "-", ":", ";"]);
  const shouldTrim = (char: string) => char.trim() === "" || punctuation.has(char);

  let start = 0;
  let end = value.length;

  while (start < end && shouldTrim(value[start])) {
    start += 1;
  }

  while (end > start && shouldTrim(value[end - 1])) {
    end -= 1;
  }

  return value.slice(start, end);
};

export function getTimezoneName() {
  const today = new Date();
  const short = today.toLocaleDateString(undefined);
  const full = today.toLocaleDateString(undefined, { timeZoneName: "long" });

  // Trying to remove date from the string in a locale-agnostic way
  const shortIndex = full.indexOf(short);
  if (shortIndex >= 0) {
    const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);

    // Trim whitespace and punctuation from both ends without relying on complex regex
    return trimWhitespaceAndPunctuation(trimmed);
  } else {
    // In case short representation of date is not present in the long one, just return the full one as a fallback
    return full;
  }
}

export const buildFormData = (formData: FormData, data: any, parentKey?: string) => {
  if (Array.isArray(data)) {
    data.forEach((el) => {
      buildFormData(formData, el, parentKey);
    });
  } else if (typeof data === "object" && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}.${key}` : key);
    });
  } else {
    if (!data) {
      return;
    }

    const value = typeof data === "boolean" || typeof data === "number" ? data.toString() : data;
    formData.append(parentKey as string, value);
  }
};
export const customSorting = (arr: any[], sortWith: string, order?: string, notDate?: boolean) => {
  //defult sort with decinding order
  if (order && order === "dec") {
    if (arr.length) {
      arr.sort((x, y) => {
        const xDate = notDate ? x[sortWith] : setDateTimeFormate(x[sortWith], "YYYY-MM-DDTHH:mm");
        const yDate = notDate ? y[sortWith] : setDateTimeFormate(y[sortWith], "YYYY-MM-DDTHH:mm");
        if (xDate > yDate) {
          return -1;
        }
        if (xDate < yDate) {
          return 1;
        }
        return 0;
      });
      return arr;
    }
    return [];
  } else {
    if (arr.length) {
      arr.sort((x, y) => {
        const xDate = notDate ? x[sortWith] : setDateTimeFormate(x[sortWith], "YYYY-MM-DDTHH:mm");
        const yDate = notDate ? y[sortWith] : setDateTimeFormate(y[sortWith], "YYYY-MM-DDTHH:mm");
        if (xDate < yDate) {
          return -1;
        }
        if (xDate > yDate) {
          return 1;
        }
        return 0;
      });
      return arr;
    }
    return [];
  }
};
export const delayWithTime = (len: number) =>
  new Promise((resolve) => setTimeout(resolve, len * 200));
